'use client';
import { SectionContainer } from '../component/SectionContainer';
import { CooperateCategoryItem, CooperateItem } from '../type';
import { useLocale } from 'use-intl';
import { getCMSIntlVal } from '../utils/common';
import Image from '../../../image';

const CooperateList = ({ list }: { list: CooperateItem[] }) => {
  return (
    <div className="grid grid-cols-6 gap-[12px] mobile:grid-cols-3 mobile:gap-[4px]">
      {list.map((item, index) => {
        return (
          <Image
            width={100}
            height={82}
            src={item.imgUrl}
            key={index}
            alt={item.name}
            loading="lazy"
            className="w-full mobile:h-10 "
          ></Image>
        );
      })}
    </div>
  );
};

export default function MeetingCooperateSection({
  data,
}: {
  data: CooperateCategoryItem[];
}) {
  const locale = useLocale();
  return (
    <div className="flex flex-col gap-[100px] mobile:gap-[72px]">
      {data.map((item, index) => {
        const { cooperateList } = item || {};
        const title = getCMSIntlVal(item, 'title', locale);
        return (
          <SectionContainer
            title={title}
            key={index}
            className="!mb-0"
            titleClassName="!text-[40px] !mb-8 mobile:!text-[24px] mobile:!mb-6"
          >
            <CooperateList list={cooperateList}></CooperateList>
          </SectionContainer>
        );
      })}
    </div>
  );
}
